import { useQuery } from 'react-query';

import { G } from '@mobily/ts-belt';

import { requestGQL } from '../../../common/graphQlClient';
import { isTestEnv, oneHourInMs } from '../../../config';
import { GET_PREMISES, GetPremisesResponse } from '../api';
import { parseGetPremisesResponse } from '../Premise';

export const allPremisesKey = (propertyId: number | null) => ['allPremises', propertyId] as const;

export const fetchPremises = (propertyId: number | null) => () =>
  requestGQL<GetPremisesResponse>(GET_PREMISES, { propertyId });

export const usePremisesList = (propertyId: number | null) => {
  return useQuery(allPremisesKey(propertyId), fetchPremises(propertyId), {
    refetchOnWindowFocus: false,
    retry: isTestEnv ? 0 : 3,
    staleTime: oneHourInMs,
    enabled: G.isNotNullable(propertyId),
    select: (data) => parseGetPremisesResponse(data),
  });
};
